import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import "./Blog.css";
import { blogPosts } from "../data/blogPosts";

function BlogIndex() {

  return (
    <>
      <SEO />
      <motion.div
        className="blog-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <div className="blog-index-container">
          <header className="blog-index-header">
            <h1>WaveTech Solutions Blog</h1>
            <p>Expert guides, tips, and insights for Shopify merchants</p>
          </header>

          <div className="blog-posts-grid">
            {blogPosts.map((post, idx) => (
              <motion.article
                key={idx}
                className="blog-post-card"
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ 
                  delay: idx * 0.15,
                  duration: 0.6,
                  type: "spring",
                  stiffness: 100
                }}
                whileHover={{ 
                  y: -10,
                  scale: 1.02,
                  transition: { duration: 0.3 }
                }}
              >
                <div className="blog-post-meta">
                  <span className="blog-post-category">{post.category}</span>
                  <span className="blog-post-date">{new Date(post.date).getFullYear()}</span>
                </div>
                <motion.h2
                  whileHover={{ x: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link to={post.link}>{post.title}</Link>
                </motion.h2>
                <p>{post.description}</p>
                <motion.div
                  whileHover={{ x: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link to={post.link} className="read-more-link">
                    Read More →
                  </Link>
                </motion.div>
              </motion.article>
            ))}
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default BlogIndex;

